import styled from 'styled-components';
import { toRem, theme } from '../../styles';

export const StyledThankYouContainer = styled.div`
  h1 {
    font: normal normal var(--t-title-m-font-weight) ${toRem(60)} / normal var(--t-title-font-family);
    text-transform: none;
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 10px !important;
      font: normal normal var(--t-title-m-font-weight) ${toRem(30)} / normal var(--t-title-font-family);
    }
    b {
      font-weight: var(--t-title-m-font-weight) !important;
      @media ${theme.mediaQuery.allMobiles} {
        display: block;
        font-weight: var(--t-title-m-font-weight) !important;
      }
    }
  }

  .thankYouPage {
    .container {
      @media ${theme.mediaQuery.largeDesktop} {
        max-width: 800px;
      }
    }
  }

  .begin-button {
    font: normal normal 700 ${toRem(14)} / ${toRem(17)} var(--t-base-font-family) !important;
    margin: 0 auto !important;
    max-width: 155px;
    width: 100%;
    padding: 11px 11px 12px 11px !important;
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal 700 ${toRem(13)} / ${toRem(16)} var(--t-base-font-family) !important;
      max-width: 274px;
      height: auto;
      padding: 8px 16px !important;
    }
  }

  .thankyou-Wrapper {
    text-align: center;
    padding: 64px 0 64px;
    @media ${theme.mediaQuery.allMobiles} {
      text-align: left;
      padding: 27px 0 27px;
    }
    a {
      text-decoration: underline !important;
      font-weight: 400 !important;
    }
  }

  .privacytext {
    p {
      margin-bottom: 24px !important;
      @media ${theme.mediaQuery.allMobiles} {
        margin-bottom: 32px !important;
      }
    }
  }

  p,
  div {
    &.t-font-m {
      font: normal normal var(--t-title-m-font-weight) 1rem/1.5rem var(--t-base-font-family);
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family);
      }
    }
  }

  a {
    text-decoration: underline;
  }

  .container-custom {
    min-height: 142px;
    background: #fff;
    padding: 0;
    margin-top: 15px;
    text-align: left;
    max-width: 800px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    border: 1px solid #dcdcdc;
  }

  .container-custom h2 {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 0;
    color: var(--t-brand-fg-color);
  }
  .container-custom p {
    color: var(--t-brand-fg-color);
  }

  .left-image-ab {
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 100%;
    aspect-ratio: 1;
    // width: 142px;
  }

  .right-content-ab {
    padding: 16px 16px 16px 26px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .cta-button-ab {
    max-width: fit-content;
    width: 100%;
    font: normal normal 700 0.875rem / 1.0625rem var(--t-base-font-family) !important;
    padding: 11px 11px 12px !important;
  }
  .container-custom a {
    color: var(--t-button-primary-fg-color) !important;
    background-color: var(--t-button-primary-bg-color) !important;
    text-decoration: none !important;
  }
  .thankyou-Wrapper.calloutComponent {
    padding-bottom: 0 !important;
  }
  @media (max-width: 767px) {
    .container-custom.d-flex.flex-md-row {
      flex-direction: column !important;
      padding: 0 !important;
    }
    .left-image-ab {
      height: 100px;
      background-position: center 25%;
      width: 100%;
    }
    .right-content-ab {
      padding-left: 16px !important;
    }
    .box-section-model {
      padding: 30px 16px;
    }
  }
  .image.left-image-ab {
    object-fit: cover;
    object-position: center 25%;
  }
`;
